// Function to get URL queries as object
// eg. getUrlQueries('http://localhost:3000/?name=John&age=20') = { name: 'John', age: '20' }

function getUrlQueries(
  url: string = window.location.search
): Record<string, string> {
  const urlData = new URLSearchParams(url);
  const resultData: Record<string, string> = {};
  for (const [key, value] of urlData.entries()) {
    resultData[key] = value;
  }
  return resultData;
}

// Function to build a URL with query params from an object (ignores empty values).
// eg. buildUrl('/customer/location', { 'page-id': '123', token: '' }) = '/customer/location?page-id=123'
function buildUrl(path: string, params?: Record<string, string>) {
  const searchParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();

  return queryString ? `${path}?${queryString}` : path;
}

export const urlUtility = { getUrlQueries, buildUrl };
